import LazyLoad from 'vanilla-lazyload';

$(function () {
  // Match the attributes emitted by CreateLazyImg and the theme's CSS classes.
  const lazyLoad = new LazyLoad({
    elements_selector: 'img[data-lazy-src], [data-bg]',
    data_src: 'lazy-src',
    data_srcset: 'lazy-srcset',
    data_sizes: 'lazy-sizes',
    class_loading: 'lazyloading',
    class_loaded: 'lazyloaded',
    class_error: 'lazyerror',
    threshold: 300,
  });

  // Pick up images added by the theme's AJAX lists and Gravity Forms.
  $(document).on('ajaxComplete gform_post_render', () => lazyLoad.update());
});
